<template>
  <div class="youtaofang">
    <topTitle
      title="柏庭荟"
      :list="list"
      :newData="newData"
      :ContentStatus="ContentStatus"
      :remakTitle="remakTitle"
    ></topTitle>
    <p class="top_p">钱湖柏庭园艺俱乐部有2个社团，分别是农丰社团、花艺社团。</p>
    <p class="top_p title" style="margin: 0">一、农丰社团</p>
    <p class="top_p" style="margin: 0">
      农丰社团的成员都是爱好农艺技艺和蔬果种植的长者们，通过种植、交流、互动、分享等活动落实“农丰事业”，获得丰收的喜悦和幸福。
    </p>
    <p class="top_p" style="margin: 0">
      近距离接触大自然，呼吸泥土的芬芳，感受大山的馈赠，自己动手，丰衣足食。
    </p>
    <p class="top_p" style="margin: 0">
      柏庭的农丰社团是热爱动手的长者们最爱的社团之一了~
      在收获自己亲手种下果实的那一刻，脸上的笑容是止不住的。
    </p>
      <p class="top_p title" style="margin: 0">二、花艺社团</p>
    <p class="top_p" style="margin: 0">
      花艺指通过一定技术手法，将花材排列组合或者搭配使其变得更加的赏心悦目，表现一种意境或宏观场面，体现自然与人以及环境的完美结合，形成花的独特语言，让观赏者解读与感悟。
    </p>
    <p class="top_p" style="margin: 0">
      花艺社团更是将这些观赏者汇聚一堂，一起徜徉在大自然最美的风景里。
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/yuanyi.jpg" alt="" />
    </div>
    <!-- <div class="item_bd" v-if="ContentStatus==false">
      <img :src="item.img" alt="" v-for="(item, key) in list2" :key="key" />
    </div>
     <div href="" class="navGet" @click="getHtml('3')" v-if="ContentStatus==false">“最美东钱湖”老年摄影大赛暨钱湖柏庭老年摄影俱乐部成立</div>
     <p v-html="dataContent" v-if="ContentStatus"></p> -->
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
import axios from "axios";
export default {
  name: "youtaofang",
  data() {
    return {
      list: [
        {
          title: "柏庭荟简介",
          small_title: "BOTING LIVING CLUB INTRODUCTION",
          hasTitle: "柏庭荟简介",
        },
        {
          title: "运动俱乐部",
          hasTitle: "运动俱乐部",
        },
        {
          title: "文艺俱乐部",
          hasTitle: "文艺俱乐部",
        },
        {
          title: "休闲俱乐部",
          hasTitle: "休闲俱乐部",
        },
        {
          title: "健身俱乐部",
          hasTitle: "健身俱乐部",
        },
        {
          title: "桌游俱乐部",
          hasTitle: "桌游俱乐部",
        },
        {
          title: "声乐俱乐部",
          hasTitle: "声乐俱乐部",
        },
        {
          title: "书画俱乐部",
          hasTitle: "书画俱乐部",
        },
        {
          title: "外语俱乐部",
          hasTitle: "外语俱乐部",
        },
        {
          title: "园艺俱乐部",
          hasTitle: "园艺俱乐部",
        },
      ],
      newData: 9,
      list2: [
        {
          img: require("../../assets/image/party/item_1.png"),
        },
        {
          img: require("../../assets/image/party/item_2.png"),
        },
        {
          img: require("../../assets/image/party/item_3.png"),
        },
      ],
      dataContent: "",
      ContentStatus: false,
      remakTitle: "",
    };
  },
  methods: {
    getHtml(e) {
      this.$router.push({
        path: "/Meeting/getlist",
        query: { majorName: e },
      });
    },
  },
  mounted: function () {},
  components: {
    topTitle,
  },
  props: {},
};
</script>
<style scoped="scoped">
p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
}
.youtaofang {
  width: 100%;
  height: 100%;
  text-align: left;
}
.top_p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
  text-indent: 2em;
}
.item_bd {
  margin-top: 1.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item_bd img {
  width: 4.0125rem;
  /* height: 3.0125rem; */
  border-radius: 0.125rem;
}
.navGet {
  display: inline-block;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  text-decoration: underline;
  color: #3f674b;
  line-height: 54px;
  text-align: left;
  margin-top: 0.6rem;
  cursor: pointer;
}
.item_img {
  width: 100%;
  padding: 0.5625rem 0.3rem;
}
.item_img > img {
  width: 100%;
  height: auto;
}
.title {
  font-weight: 800 !important;
}
</style>